import { render } from "./RightBar.vue?vue&type=template&id=445be20a&scoped=true"
import script from "./RightBar.vue?vue&type=script&lang=js"
export * from "./RightBar.vue?vue&type=script&lang=js"

import "./RightBar.vue?vue&type=style&index=0&id=445be20a&lang=less&scoped=true"
const cssModules = {}
import style1 from "./RightBar.vue?vue&type=style&index=1&id=445be20a&module=true&lang=less"
cssModules["$style"] = style1

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__scopeId',"data-v-445be20a"]])

export default __exports__